<template>
  <div id="Market" class="full_layout market" v-loading.fullscreen="loading">
    <div class="breadcrumbANDsort">
      <div class="breadcrumb">
        <router-link :to="{path:'/'}">Home</router-link>
        <router-link v-if="fname!=''" :to="{path:'/market?f='+fid}">{{fname}}</router-link>
        <!-- <span v-if="fname!=''">{{fname}}</span> -->
        <span v-if="sname!=''">{{sname}}</span>
        <span v-if="searchTxt">{{searchTxt}}</span>
      </div>
      <div class="sort">
        <span class="" :class="isSort == 0 ? 'on' : ''" @click="sort(0)">Newly Released</span>
        <span class="sort_price" :class="isSort == 1 ? 'on' : ''" @click="sort(1)">
          Price
          <em class="up_arr" :class="isPrice ? 'up' : ''"></em>
          <em class="up_down" :class="!isPrice && isPrice != null ? 'up' : ''"></em>
        </span>
        <span class="sort_price" :class="isSort == 2 ? 'on' : ''" @click="sort(2)">
          Sales
          <em class="up_arr" :class="isVolume ? 'up' : ''"></em>
          <em class="up_down" :class="!isVolume && isVolume != null ? 'up' : ''"></em>
        </span>
      </div>
    </div>
    <div class="space_between">
      <div class="productsClassBox">
        <div class="productsClass">
          <div class="productsClassTitle">Filter by</div>
          <div class="CategoryLIst" v-for="(item,index) in category" :key="index" :class="[categoryArray[index]['isType']?'up':'']" v-if="categorylist==0">
            <div class="CategoryTitle" @click="listTransform(item.id,index)">
              {{item.label}}
            </div>
            <ul>
              <li v-for="(it,i) in item.children" :key="i">
                <span @click="MenuUserGo('/market?f='+it.Fid+'&s='+it.id+'&search='+searchTxt,'market')">{{it.label}}</span>
              </li>
            </ul>
          </div>
          <div class="productScreenBox" v-if="property!=null&&categorylist!=0">
            <el-collapse v-model="openeds" class="productCollapse">
              <el-collapse-item :name="index+1" v-for="(item,index) in property" :key='index'>
                <template slot="title">
                  {{item.Property.EnName}}
                </template>
                <div class="productCollapseList">
                  <el-checkbox-group v-model="checkList[item.Property.ControlName]" class="productScreenCheckbox" @change='checkboxChange(checkList[item.Property.ControlName],item.Property.ControlName)'>
                    <div v-for="(it,j) in item.PropertyKeyValues" :key="j">
                      <el-checkbox :label="it.ChName">{{it.EnName}}</el-checkbox>
                    </div>
                  </el-checkbox-group>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
      </div>
      <div class="productsListBox" v-if="!isNull">
        <div class="ball" ref="ball" v-if="list!=null"></div>
        <ul class="products" v-if="list!=null">
        <li v-for="(item,index) in list" :key="index" :class="{'presale':(item.Presale==1)}">
            <i v-if="item.Status==2"></i>
            <i v-if="item.Presale==1" ></i>
            <div class="outOfStock" v-if="item.QuantitySold<=0">Out of stock</div>
            <el-button v-if="(userInfo!=null&&item.QuantitySold>0)&&item.Presale!=1" type="primary" class="addCart" @click="toCart($event,item)">Add to cart</el-button>
            <router-link :to="{path:'/market/item/'+item._id+'?type='+(fname!=''&&sname!=''?'0':'1')}">
              <div class="imgBox">
                <img :src="item.TitImg+'?imageView2/2/w/238'">
              </div>
              <div class="line_txt3 productsText">
                {{item.Title}}{{item.Status}}{{item.Presale}}
              </div>
              <template v-if="userInfo">
                <div class="productsPrice" v-if="isShowPrice(item)">{{item.Price.toLocaleString()}}</div>
              </template>
            </router-link>
        </li>
          <!-- <li v-for='(item,index) in list' :key='index' :class="[item.Status==2&&item.Presale!=1?'outStock':'',item.Status!=2&&item.QuantitySold<=0&&item.Presale!=1?'sold':'',item.Presale==1?'presale':'']">
            <i v-if="item.Status==2"></i>
            <i v-if="item.Presale==1"></i>
            <div class="outOfStock" v-if="item.QuantitySold<=0">缺货</div>
            <el-button v-if="(userInfo!=null&&item.QuantitySold>0)&&item.Presale!=1" type="primary" class="addCart" @click="toCart($event,item)">Add to cart</el-button>
            <router-link :to="{path:'/market/item/'+item._id+'?type='+(fname!=''&&sname!=''?'0':'1')}">
              <div class="imgBox">
                <img :src="item.TitImg+'?imageView2/2/w/238'">
              </div>
              <div class="line_txt3 productsText">
                {{item.Title}}
              </div>
              <div class="productsPrice" v-if="isShowPrice(item)">{{item.Price.toLocaleString()}}</div>
            </router-link>
          </li> -->
        </ul>
        <pagination :TotalCount="TotalCount" :ps="ps" @ps='pageSize' @pi='pageIndex' v-if="list!=null" />
      </div>
      <div class="productsListBox" v-if="isNull">
        <nonull type='item' text="No products found" />
      </div>
    </div>
  </div>
</template>
<script>
import { CookiesCategory, getInfo } from "@/api/public";
import Pagination from '@/components/pagination'
import Nonull from '@/components/nonull'
export default {
  name: 'market',
  components: { Pagination, Nonull },
  data() {
    return {
      isNull: false,
      userInfo: getInfo(),
      loading: false,
      category: null,
      checkList: {},
      openeds: [1, 2],
      isSort: 0,
      dakaSort: this.$enumInfo.sort[0],
      dakaSortType: this.$enumInfo.sortType[0],
      isPrice: null,
      isVolume: null,
      list: null,
      property: null,
      categoryArray: [],
      categorylist: null,
      ps: 24, //pagesize
      pi: 1, //pageindex
      TotalCount: 0,
      searchTxt: '',
      fid: '',
      sid: '',
      fname: '',
      sname: '',
    }
  },
  mounted() {
    this.$root.$on("newSearch", val => {
      this.searchTxt = val;
    })
  },
  watch: {
    '$route': 'getPath'
  },
  created() {
    this.getPath()
  },
  methods: {
    isShowPrice(obj){
      if(obj.QuantitySold>0){
        return true
      }else{
        if(obj.HideType==1){
          return false
        }else{
          return true
        }
      }
    },
    getPath() {
      this.userInfo = getInfo()
      this.getCategoryList()
    },
    // 获取类目
    getCategoryList() {
      let that = this
      that.categorylist = null;
      that.categoryArray = []
      let fun = function(res) {
        console.log(res,'res')
        that.category = res;
        if (that.$route.query.f) {
          that.searchTxt=that.$route.query.search
          that.$root.$emit("newSearch", that.searchTxt);
          that.fid = that.$route.query.f
          that.sid = that.$route.query.s
          console.log('that.$route.query.f', that.$route.query.f)
          console.log('that.$route.query.s', that.$route.query.s)
          res.map(res => {
            that.categoryArray.push({ id: res.id, isType: (res.id == that.fid ? true : false) })
            if (res.id == that.fid) {
              that.fname = res.label;
              if (that.sid) {
                res.children.map(it => {
                  if (it.id == that.sid) {
                    that.sname = it.label
                  }
                })
              }
            }
          })
          that.getKeyValue()
        } else {

          that.categoryArray = []
          that.categorylist = 0;
          res.map(res => {
            that.categoryArray.push({ id: res.id, isType: false })
          })
          that.searchTxt=that.$route.query.search||''
          console.log('that.searchTxt',that.searchTxt)
          that.$root.$emit("newSearch", that.searchTxt);
          //that.$root.$emit("newSearch", '');
          that.fid = ''
          that.sid = ''
          that.fname = ''
          that.sname = ''
        }

        that.getCommodityList()

      }
      CookiesCategory('get', '', 'miaoshop', fun)
    },
    // 获取类目下的属性
    getKeyValue() {
      let that = this;
      let data = { FirstCategoryId: that.fid }
      that.$get(that.$interface.GetKeyValueByFirstCategoryId, data).then(res => {
        if (res.Result != 3) {
          let newArray = {};
          that.property = res.Data;
          res.Data.map(item => {
            newArray[item.Property.ControlName] = []
          })
          that.checkList = newArray
        }
      })
    },
    // 获取商品列表
    getCommodityList() {
      let that = this;
      that.loading = true;
      that.isNull = false;
      let checkList=that.checkList;
      let Year=""
      let Version=""
      let Series=""

      if(checkList.Year&&checkList.Year!=undefined){
        Year=checkList.Year.join(',')
      }
      if(checkList.Version&&checkList.Version!=undefined){
        Version=checkList.Version.join(',')
      }
      if(checkList.Series&&checkList.Series!=undefined){
        Series=checkList.Series.join(',')
      }
      let data = {
        FirstCategoryId: that.fid,
        SecondCategoryId: that.sid,
        Title: that.searchTxt,
        Sort: that.dakaSort,
        SortType: that.dakaSortType,
        PageIndex: that.pi,
        PageSize: that.ps,
        Year:Year,
        Version:Version,
        Series:Series
      }
      console.log(data,'data')
      //data = Object.assign({}, data, that.checkList)
      that.$get(that.$interface.GetCommodities, data).then(res => {
        if (res.Result != 0) {
          that.TotalCount = res.Count;
          that.list = res.Data;
          if (res.Count <= 0) {
            console.log(res.Count)
            that.isNull = true;
          }
        } else {
          that.list = null;
          that.isNull = true;
        }
        that.loading = false;
      })
    },
    // 筛选属性
    checkboxChange(obj, val) {
      this.getCommodityList()
    },
    // 跳转链接
    MenuUserGo(val, name) {
      this.$router.push({ path: val })
    },
    // 类目树状闭合
    listTransform(id, type) {
      let that = this
      let array = that.categoryArray;
      array.map(res => {
        if (res.id == id) {
          res.isType = !res.isType
        }
      })
      that.categoryArray = array
    },
    // 添加购物车
    toCart(e, obj) {
      let that = this;
      let data = { commodityId: obj._id, num: 1, memberId: that.userInfo._id, type: true }
      that.$post(that.$interface.AddMyCart, data).then(res => {
        if (res.Result != 0) {
          // this.$refs.ball.style.top = e.pageY + 'px';
          // this.$refs.ball.style.left = e.pageX + 'px';
          // setTimeout(function() {
          //   that.$refs.ball.className = 'ball ball_hover'
          // }, 200)
          // setTimeout(function() {
          //   that.$refs.ball.className = 'ball'
          // }, 500)
          
          that.$root.$emit("newCart", "true");
          this.toCartBox(obj)
        } else {
          that.$message.error(res.Msg);
        }
      })
    },

    toCartBox(obj){
      let that=this
      let title='Added to cart！';
      let html='<div style="display: flex;">'
      +'<img style="width: 120px;height: 120px;object-fit: contain;border: 1px solid #F0F0F0;border-radius: 8px;margin-right: 10px;" src='+obj.TitImg+' />'
      +'<div style="width: 65%;">'+obj.Title+'<span style="display: block;">Quantity：1</span></div>'
      +'</div>'
      this.$confirm(html, title, {
          dangerouslyUseHTMLString: true,
          showCancelButton:false,
          lockScroll:false,
          confirmButtonText:'Go to cart'
        }).then(() => {
            
      that.$root.$emit("newCart", "true");
      that.$router.push({ path: '/cart' })
          });
    },
    // 排序
    sort(val) {
      let that = this;
      that.pi = 1;
      that.isSort = val;
      that.dakaSort = this.$enumInfo.sort[val]
      if (val == 1) {
        that.isPrice = !that.isPrice;
        var i = that.isPrice ? 1 : 0
        that.dakaSortType = that.$enumInfo.sortType[i]
        console.log(i, that.isPrice, that.$enumInfo.sortType[i], that.dakaSortType)

      } else {
        that.isPrice = null
      }
      if (val == 2) {
        that.isVolume = !that.isVolume;
        var i = that.isVolume ? 1 : 0
        that.dakaSortType = that.$enumInfo.sortType[i]
      } else {
        that.isVolume = null
      }

      that.getCommodityList()
    },
    // 每页几条
    pageSize(val) {
      this.ps = val
      this.getCommodityList()

    },
    // 页码
    pageIndex(val) {
      this.pi = val
      this.getCommodityList()
    }
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/market.css";

</style>



// WEBPACK FOOTER //
// src/pages/market/index.vue